precision mediump float;

uniform float uTime;
uniform float uHeight;

varying vec2 vUv;
varying float vHeight;


void main() {
    vUv = uv;

    // Normalize height from [-uHeight/2, uHeight/2] -> [0, 1]
    float h = (position.y + (uHeight * 0.5)) / max(0.0001, uHeight);
    vHeight = clamp(h, 0.0, 1.0);

    // Taper the cylinder towards the top to resemble a flame
    // 1.0 at bottom -> 0.25 at top
    float taper = mix(1.0, 0.25, vHeight);

    // Gentle horizontal wobble
    float wobbleA = sin(position.y * 20.0 + uTime * 8.0) * 0.005;
    float wobbleB = cos(position.y * 17.0 + uTime * 7.0) * 0.004;

    vec3 pos = position;
    pos.xz *= taper;
    pos.x += wobbleA;
    pos.z += wobbleB;

    gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);
}

